export const MERCHANT_RULES = {
  maxHealth: 2500,
  radius: 0.45,
  reach: 2.2,
  absenceWaves: 3,
  revivePrice: 300,
  enemyAggroRadius: 3.5,
  playerPriorityRadius: 3,
} as const;
